import { storeDataInLocalStorage, getDataInLocalStorage } from "../../_common/localStorage";
import { isMaxUser } from "../utils";

export const preferenceKey = `user-view-preference`;
export const defaultKeyValue = (win: WindowProxy): string => win.document.querySelector(`[data-default-view]`).id;
export const saveUserViewPref = (isMaxUser: boolean, view: string) => {
  if (isMaxUser) {
    storeDataInLocalStorage(`max-${preferenceKey}`, view);
  } else {
    storeDataInLocalStorage(preferenceKey, view);
  }
};

export const loadUserViewPref = (isMaxUser: boolean): string => {
  if (isMaxUser) {
    return getDataInLocalStorage(`max-${preferenceKey}`);
  } else {
    return getDataInLocalStorage(preferenceKey);
  }
};

export function saveUserViewPreference(maxUser) {
  const selectedView = this.querySelector(`.active`).id;
  saveUserViewPref(maxUser, selectedView);
}

const initialize = (win: WindowProxy) => {
  const maxUser = isMaxUser(win);
  const buttonGroup = win.document.querySelector(`.view-menu__v-btn-group`);

  if (buttonGroup) {
    buttonGroup.addEventListener(`click`, saveUserViewPreference.bind(buttonGroup, maxUser));
    const savedView = loadUserViewPref(maxUser);
    if (savedView) {
      win.document.getElementById(savedView).click();
    } else {
      saveUserViewPref(maxUser, defaultKeyValue(win));
    }
  }
};
export default initialize;
